import React, { Component } from "react";
import { connect } from "react-redux";
import { FormInput, ActionWithPlus } from "../../../components";
import { back, push } from "../../../actions/nav-actions";
import { fetchGoals, updateAllGoals, postGoal, removeGoal } from "../../../api";
import { notify } from "../../../utils";

class EvaluateContext extends Component {
  state = {
    project: {},
    is_loading: false,
    error: undefined,
    data: {},
    type: "goal",
    name: "",
  };
  constructor(props) {
    super(props);
    this.request = this.request.bind(this);
    this.getParams = this.getParams.bind(this);
    this.requestNew = this.requestNew.bind(this);
    this.requestDelete = this.requestDelete.bind(this);
    this.deleteGoal = this.deleteGoal.bind(this);
  }
  requestDelete(type, goal) {
    let response = window.confirm(`Are you sure you want to delete ${type}?`);
    if (response) {
      this.deleteGoal(type, goal);
    }
  }
  deleteGoal(type, goal) {
    const params = this.getParams();
    removeGoal(this.props.user.token, params.organization, params.code, {
      type,
      goal,
    })
      .then((data) => {
        this.setState({ is_loading: false, data });
      })
      .catch((err) => {
        alert(err.message);
      });
  }
  getParams() {
    return this.props.match.params || {};
  }
  componentDidMount() {
    const params = this.getParams();
    this.setState({ is_loading: true, error: undefined }, () => {
      fetchGoals(this.props.user.token, params.organization, params.code)
        .then((data) => this.setState({ is_loading: false, data }))
        .catch((err) => this.setState({ is_loading: false, error: err }));
    });
  }
  request() {
    const params = this.getParams();
    updateAllGoals(this.props.user.token, params.organization, params.code, {
      goals: this.state.data.goals,
    })
      .then((data) => notify("Update informations", "Successfully updated!"))
      .catch((err) => notify("Error", err.message, "error"));
  }
  requestNew(type, goalId, name) {
    if (!name) return;
    if (name.trim().length === 0) return;
    let body_goal = {
      name,
      type,
    };
    if (goalId) body_goal.goal = goalId;
    const params = this.getParams();

    postGoal(this.props.user.token, params.organization, params.code, body_goal)
      .then(({ goal }) => {
        let { data } = this.state;
        if (type === "goal") {
          data[`${goal.type}s`] = data[`${goal.type}s`].concat([goal]);
        } else {
          data.goals = data.goals.map((g) => {
            if (g._id === goal.goal) {
              g.subgoals = g.subgoals.concat([goal]);
              g.new_subgoal_text = "";
              return g;
            }
            return g;
          });
        }
        this.setState({
          name: "",
          data: { ...data },
        });
      })
      .catch((err) => {
        alert(err.message);
      });
  }
  render() {
    if (this.state.error) return <span>{this.state.error.message}</span>;
    if (!this.state.data.goals || this.state.is_loading)
      return <span>Loading data...</span>;
    let { goals } = this.state.data;
    return (
      <React.Fragment>
        <div>
          {goals.map((goal, index) => {
            return <Goals position={index + 1} key={index} goal={goal} />;
          })}
        </div>

        <div>
          {goals.map((goal, index) => {
            return (
              <div>
                <div style={{ marginHorizontal: 24 }}>
                  <div
                    style={{ flex: 1, display: "flex", flexDirection: "row" }}
                  >
                    <FormInput
                      value={goal.name}
                      onChange={(name) => {
                        goal.name = name;
                        goals[index] = goal;
                        this.setState({ data: { ...this.state.data, goals } });
                      }}
                      containerStyle={{ flex: 1 }}
                      placeholder="Please state your goal"
                    />
                    <div className="form-group" style={{ marginLeft: 16 }}>
                      <button
                        onClick={() => this.requestDelete("goal", goal._id)}
                        className="btn btn-primary magenta-background"
                      >
                        Remove Goal
                      </button>
                    </div>
                  </div>

                  <p style={{ marginTop: 8 }}>Subgoals</p>
                  {goal.subgoals.map((subgoal, sub_index) => {
                    return (
                      <div
                        style={{
                          flex: 1,
                          marginTop: 8,
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <FormInput
                          value={subgoal.name}
                          onChange={(name) => {
                            subgoal.name = name;
                            goals[index].subgoals[sub_index] = subgoal;
                            this.setState({
                              data: { ...this.state.data, goals },
                            });
                          }}
                          containerStyle={{ flex: 1 }}
                          placeholder="Please state your subgoal"
                        />
                        <div className="form-group" style={{ marginLeft: 16 }}>
                          <button
                            onClick={() =>
                              this.requestDelete("subgoal", subgoal._id)
                            }
                            className="btn btn-primary magenta-background"
                          >
                            Remove Subgoal
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div style={{ marginHorizontal: 24, marginTop: 16 }}>
                  <FormInput
                    value={goal.new_subgoal_text}
                    onChange={(text) => {
                      goal.new_subgoal_text = text;
                      goals[index] = goal;
                      this.setState({ data: { ...this.state.data, goals } });
                    }}
                    placeholder="Please state your new subgoal"
                  />

                  <ActionWithPlus
                    style={{ marginTop: 16, marginBottom: 16 }}
                    onClick={this.requestNew.bind(
                      this,
                      "subgoal",
                      goal._id,
                      goal.new_subgoal_text
                    )}
                    label="Save as new Subgoal"
                  />
                </div>
              </div>
            );
          })}
          <div style={{ marginTop: 16, marginHorizontal: 24 }}>
            <FormInput
              value={this.state.name}
              onChange={(name) => {
                this.setState({ name });
              }}
              placeholder="Please state your new goal"
            />

            <ActionWithPlus
              style={{ marginTop: 16 }}
              onClick={this.requestNew.bind(
                this,
                "goal",
                undefined,
                this.state.name
              )}
              label="Save as new Goal"
            />
          </div>
        </div>

        <button
          className="btn btn-info"
          onClick={this.request.bind(this)}
          style={{ marginTop: 24, marginBottom: 24 }}
        >
          SAVE
        </button>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({ user: state.authReducer.user });

const mapDispatchToProps = (dispatch) => ({
  back() {
    dispatch(back());
  },
  push(routeName) {
    dispatch(push(routeName));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(EvaluateContext);

const Goals = (props) => {
  return (
    <div
      style={{
        marginBottom: "16px",
        border: "1px solid #CCC",
        borderRadius: "4px",
      }}
    >
      <div style={{ padding: "16px", borderBottom: "1px solid #CCC" }}>
        <span>
          <b>
            Goal {props.position}: {props.goal.name}
          </b>
        </span>
      </div>
      {props.goal.subgoals.length == 0 && (
        <div style={{ margin: "16px" }}>
          <span>
            No subgoals related to goal <b>{props.goal.name}</b>
          </span>
        </div>
      )}
      {props.goal.subgoals.map((subgoal, subgaolIndex) => {
        return (
          <div style={{ margin: "16px" }}>
            <span>
              Subgoal: {props.position}.{subgaolIndex + 1}: {subgoal.name}
            </span>
          </div>
        );
      })}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/routers/Projects/Formularies/GoalsAndObjectivesFormularies.js